<style scoped lang="scss" type="text/scss">
    .information-container {
        max-height: 100%;
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .content-container {
            flex: 1;
            margin-top: 1rem;
            display: flex;
            align-items: flex-start;
            width: 100%;
            overflow: hidden;

            .left-panel {
                margin-right: 1rem;
                overflow: auto;
            }

            .right-panel-container {
                flex: 1;
                overflow: auto;
            }
        }
    }
</style>

<template>
    <div class="information-container">
        <registrable-manged-player-selector></registrable-manged-player-selector>
        <div class="content-container">
            <left-panel class="left-panel" :style="{'max-height': maxHeight}"></left-panel>
            <card class="right-panel-container" :style="{'max-height': maxHeight}">
                <router-view></router-view>
            </card>
            <count-down></count-down>
        </div>
    </div>
</template>

<script>
    import LeftPanel from './left-panel';
    import Card from '../../../../components/card/index';
    import CountDown from '../../../sub-components/count-down/index';
    import RegistrableMangedPlayerSelector from '../../../sub-components/registrable-managed-player-selector';
    import {mapState} from "vuex";

    export default {
        name: '',
        components: {
            LeftPanel,
            Card,
            CountDown,
            RegistrableMangedPlayerSelector
        },
        data () {
            return {};
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId
            }),
            maxHeight () {
                return this.$store.getters['layout/userPlayerInformationVisualAreaHeight'] + 'px';
            }
        },
        watch: {
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                    this.$normalRequest('player/loadPlayerInfoPackage', {
                        id: this.currentManagedPlayerId
                    }, false, false, this, 'requesting').then();
                }
            }
        }
    };
</script>
